import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  ModalService, RestApiService, SecureFilePipe, UIKitIconRegistry, downloadIcon, documentIcon,
} from '@ui-kit';
import { UserService } from '../../service/user.service';

@Component({
  selector: 'app-mip-button',
  templateUrl: './mip-button.component.html',
  styleUrls: ['./mip-button.component.scss'],
  providers: [SecureFilePipe],
})
export class MipButtonComponent {
  @Input() pdfTitle: string = 'Mortgage In Principle';

  @Input() theme: string = 'flat-link';

  @Input() fullWidth: boolean = false;

  @Input() centered: boolean = false;

  @Input() prefixIcon: 'document' | 'download' = 'download';

  @Input() badgeText: string;

  @Input() badgeClass: string;

  @Input() disabled: boolean = false;

  @Input() signedInText: string = 'Download Mortgage in Principle';

  @Input() signedOutText: string = 'Get Mortgage in Principle';

  @Input() buttonClass: string = '';

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private user: UserService,
    private modal: ModalService,
    private restApi: RestApiService,
    private router: Router,
    private secureFile: SecureFilePipe,
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([
      downloadIcon,
      documentIcon,
    ]);
  }

  get signedIn() {
    return this.user.signedIn;
  }

  get hasBroker() {
    return this.user.hasBroker;
  }

  get application() {
    return this.user.application;
  }

  toggle: Dictionary<boolean> = {
    mipModal: false,
    working: false,
  };

  onMipButtonClick() {
    if (this.signedIn) {
      if (this.hasBroker) {
        this.downloadMIP();
      } else {
        this.toggle.mipModal = true;
      }
    } else {
      this.modal
        .open('In order to get a mortgage in principle, please sign up or sign in if you already have an account.', {
          ok: 'Sign in/ up',
          okTheme: 'flat-primary',
          cancel: 'Not now',
        })
        .then((result) => {
          if (result.action === 'ok') {
            this.router.navigate(['/signin']);
          }
        });
    }
  }

  downloadMIP() {
    this.toggle.working = true;
    this.change.emit(true);
    this.restApi.getMip(this.application.id)
      .toPromise()
      .then(({ key }) => this.secureFile.transform(key).toPromise())
      .then((dataUri) => {
        const aElement = document.createElement('a');
        aElement.download = this.pdfTitle;
        aElement.href = dataUri as string;
        aElement.click();
        return this.updateUser();
      })
      .catch((error) => this.modal.open(error?.message))
      .finally(() => {
        this.toggle.working = false;
        this.change.emit(false);
      });
  }

  updateUser() {
    this.user.update({}, 'mip').toPromise();
  }
}
